import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router'
import { getTopMenu } from 'src/store/data.store'
import logo from 'assets/logo/logo.svg'
import { Menu } from 'components/PageElements/Menu/Menu'
import { MenuItem } from 'components/PageElements/Menu/MenuItem'
import styles from './NavigationTop.module.scss'

export const NavigationTop: React.FC = () => {
  const menu = useSelector(getTopMenu)
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Link to={'/'} title={'На главную'} className={styles.link}>
          <img src={logo} alt={'Логотип'} className={styles.logoImage} />
        </Link>
      </div>
      <div className={styles.menu}>
        <Menu place={'header'}>
          {menu.map((el, index) => <MenuItem key={index} item={el} />)}
        </Menu>
      </div>
    </div>
  )
}
